// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cta {
  background: #fff;
  padding: 0 clamp(24px, 5vw, 56px) clamp(48px, 6vw, 80px);
}

.cta__banner {
  position: relative;
  max-width: 1400px;
  margin: 0 auto;
  border-radius: 32px;
  overflow: hidden;
}

.cta__backdrop {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.cta__bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.cta__inner {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: clamp(32px, 5vw, 64px);
  padding: clamp(40px, 5vw, 64px) clamp(32px, 5vw, 72px);
}

.cta__copy {
  flex: 1 1;
  min-width: 0;
}

.cta__title {
  margin: 0 0 clamp(24px, 3vw, 40px);
  font-family: 'Averia Serif Libre', Georgia, serif;
  font-size: clamp(2rem, 3.5vw, 3.5rem);
  font-weight: 400;
  line-height: 1.15;
  letter-spacing: -0.02em;
  color: #fff;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.cta__stores {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.cta__qr {
  flex-shrink: 0;
  width: clamp(180px, 18vw, 264px);
  height: clamp(180px, 18vw, 264px);
  border-radius: 24px;
  overflow: hidden;
  background: #fff;
}

.cta__qr img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media (max-width: 768px) {
  .cta__inner {
    flex-direction: column;
    align-items: flex-start;
    padding: 40px 28px;
  }

  .cta__qr {
    align-self: center;
  }
}

@media (max-width: 480px) {
  .cta__banner {
    border-radius: 24px;
  }

  .cta__stores {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Cta/Cta.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;EAC3B,sDAAsD;AACxD;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,iDAAiD;EACjD,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".cta {\n  background: #fff;\n  padding: 0 clamp(24px, 5vw, 56px) clamp(48px, 6vw, 80px);\n}\n\n.cta__banner {\n  position: relative;\n  max-width: 1400px;\n  margin: 0 auto;\n  border-radius: 32px;\n  overflow: hidden;\n}\n\n.cta__backdrop {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n}\n\n.cta__bg-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n\n.cta__inner {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: clamp(32px, 5vw, 64px);\n  padding: clamp(40px, 5vw, 64px) clamp(32px, 5vw, 72px);\n}\n\n.cta__copy {\n  flex: 1;\n  min-width: 0;\n}\n\n.cta__title {\n  margin: 0 0 clamp(24px, 3vw, 40px);\n  font-family: 'Averia Serif Libre', Georgia, serif;\n  font-size: clamp(2rem, 3.5vw, 3.5rem);\n  font-weight: 400;\n  line-height: 1.15;\n  letter-spacing: -0.02em;\n  color: #fff;\n  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.cta__stores {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.cta__qr {\n  flex-shrink: 0;\n  width: clamp(180px, 18vw, 264px);\n  height: clamp(180px, 18vw, 264px);\n  border-radius: 24px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.cta__qr img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n@media (max-width: 768px) {\n  .cta__inner {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 40px 28px;\n  }\n\n  .cta__qr {\n    align-self: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .cta__banner {\n    border-radius: 24px;\n  }\n\n  .cta__stores {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
